import { Injectable } from '@angular/core';
import { Session } from '../models/session';
import { BehaviorSubject } from 'rxjs';
import { ITimeSlot } from '../interfaces/i-time-slot';
import { SelectedSlotTime } from '../models/selected-slot-time';
import { TimeSlotType } from '../models/time-slot-type';
import { ApiProvider } from './api-providers/api-provider';
import { ApiProviderService } from './api-provider.service';

@Injectable({
  providedIn: 'root'
})
export class SessionsService {
  
  timeSlot: number = 60;
  duration: number = 60;
  slots : Array<Session> = [];
  selectedDate : Date = new Date();

  selectedSlots: ITimeSlot = new SelectedSlotTime(TimeSlotType.SelectedSlots);

  private clientSessionsSubject = new BehaviorSubject<Session[]>([]);
  clientSessions$ = this.clientSessionsSubject.asObservable();

  

  constructor(
    private apiProvider : ApiProviderService
  ) { }

  getSessionsByClientByCoach(idCoach: string, idClient: string, date: string, page: number, pageSize: number, showFutureSessions: boolean = true): void {
    this.apiProvider.getSessionsByCoachByClients(idCoach, idClient, date, page, pageSize, showFutureSessions)
      .subscribe(sessions => {
        this.clientSessionsSubject.next(sessions);
      });
  }
}
